<lib-dialog>
  <div class="select-dialog-content">
    <div class="dialog-header">
      <h3 class="dialog-title">{{ title }}</h3>
      <button
        type="button"
        class="close-btn"
        (click)="onCancel()"
        [disabled]="loading()"
        [attr.aria-label]="t('LAYOUT.CLOSE')"
      >
        ✕
      </button>
    </div>

    <div class="search-section">
      <div class="search-header">
        @if (!loading() && totalItems() > 0) {
          <lib-results-counter
            [label]="t('LAYOUT.SHOWING')"
            [separatorLabel]="t('LAYOUT.OF')"
            [current]="displayData().length"
            [total]="totalItems()"
            [singularLabel]="t('LAYOUT.RESULT')"
            [pluralLabel]="t('LAYOUT.RESULTS')"
          >
          </lib-results-counter>
        }
        <div class="search-wrapper">
          <lib-search
            [searchTerm]="searchTerm()"
            [placeholder]="searchPlaceholder || t('LAYOUT.SEARCH_PLACEHOLDER')"
            [debounceMs]="500"
            (searchChange)="onSearchChange($event)"
          />
        </div>
      </div>
    </div>

    @if (showError()) {
      <div class="alert-section">
        <lib-alert
          type="error"
          [title]="errorTitle()"
          [message]="errorMessage()"
          [autoClose]="true"
          [duration]="5000"
          (closed)="showError.set(false)"
        />
      </div>
    }

    @if (loading()) {
      <div class="loading-state">
        <lib-icon name="Loader" class="spin"></lib-icon>
        <span>{{ t('COMMON.LOADING') }}</span>
      </div>
    }

    @if (!loading() && displayData().length === 0 && !showError()) {
      <div class="empty-state">
        <lib-icon name="Inbox" class="empty-icon"></lib-icon>
        <p>{{ t('LAYOUT.NO_OPTIONS_FOUND') }}</p>
        @if (searchTerm()) {
          <p class="empty-hint">{{ t('COMMON.EMPTY_HINT') }}</p>
        }
      </div>
    }

    @if (!loading() && displayData().length > 0) {
      <div class="table-section">
        <lib-table
          [config]="tableConfig()"
          [data]="displayData()"
          [loading]="loading()"
          [selectable]="true"
          [multiple]="multiSelect"
          [selectedIds]="selectedIds()"
          [sortColumn]="sortColumn()"
          [sortDirection]="direccionDeLaTabla()"
          (selectionChange)="onSelectionChange($event)"
          (action)="onTableAction($event)"
          (pageChange)="onPageChange($event)"
          (sortChange)="onSortChange($event)"
        />
      </div>
    }

    @if (!loading() && displayData().length > 0 && totalPages() > 1) {
      <div class="pagination-manual">
        <div class="pagination-controls">
          <button
            class="pagination-btn"
            (click)="goToPreviousPage()"
            [disabled]="!hasPreviousPage() || loading()"
          >
            {{ t('PAGINATION.PREV') }}
          </button>

          <div class="pagination-pages">
            @for (page of visiblePages(); track page) {
              <button
                class="page-btn"
                [class.active]="page === pageIndex() + 1"
                (click)="goToPage(page - 1)"
                [disabled]="loading()"
              >
                {{ page }}
              </button>
            }
          </div>

          <button
            class="pagination-btn"
            (click)="goToNextPage()"
            [disabled]="!hasNextPage() || loading()"
          >
            {{ t('PAGINATION.NEXT') }}
          </button>
        </div>
      </div>
    }

    <div class="dialog-footer">
      <div class="selection-info">
        @if (!loading()) {
          <span class="selected-count">
            {{ selectedItemsInternal().length }}
            {{
              selectedItemsInternal().length === 1
                ? t('LAYOUT.SELECTED')
                : t('LAYOUT.SELECTED_PLURAL')
            }}
          </span>
        }
      </div>

      <div class="actions">
        <lib-button variant="secondary" type="button" [disabled]="loading()" (clicked)="onCancel()">
          {{ t('ACTIONS.CANCEL') }}
        </lib-button>
        <lib-button
          variant="primary"
          type="button"
          [disabled]="
            loading() ||
            selectedItemsInternal().length === 0 ||
            (!multiSelect && selectedItemsInternal().length > 1)
          "
          (clicked)="onSave()"
        >
          {{ t('ACTIONS.ACCEPT') }}
        </lib-button>
      </div>
    </div>

    @if (popupVisible()) {
      <div class="popup-backdrop" (click)="cerrarPopup()"></div>
      <app-accounting-account-popup
        class="accounting-popup"
        [popupData]="popupData()"
        (closed)="cerrarPopup()"
      />
    }
  </div>
</lib-dialog>
